import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { environment } from '@environments/environment';

@Component({
  selector: 'app-product-import',
  templateUrl: './product-import.component.html',
  styleUrls: ['./product-import.component.scss'],
})
export class ProductImportComponent implements OnInit, OnDestroy {
  subs = new Subscription();
  activeLinkIndex = -1;

  get devMode(): boolean {
    return environment.dev;
  }

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.navigate(this.router.url);
    this.subs = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.navigate(e.urlAfterRedirects);
      }
    });
  }

  navigate(url: string): void {
    if (url.endsWith(`/images`)) {
      this.activeLinkIndex = 0;
    } else if (url.endsWith(`/table-checker`)) {
      this.activeLinkIndex = 1;
    }
  }

  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }
}
